import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import '../../../utilities/color.js';
import 'date-fns';
import '../../../utilities/locale.js';
import '../../../hooks/use-prevent-keyboard-scrolling.js';
import { useRtl } from '../../../hooks/use-rtl.js';
import '../../../styles/styled-components/alert.js';
import '../../../styles/styled-components/animations.js';
import '../../../styles/styled-components/box-shadow.js';
import '../../../styles/styled-components/button.js';
import '../../../themes/alert.js';
import '../../../themes/button.js';
import '../../../themes/checkbox.js';
import '../../../themes/divider.js';
import '../../../themes/dropdown.js';
import '../../../themes/fieldset.js';
import '../../../themes/input.js';
import '../../../themes/list.js';
import '../../../themes/listbox.js';
import '../../../themes/loader.js';
import '../../../themes/option.js';
import '../../../themes/popout.js';
import '../../../themes/switch.js';
import { lightTheme } from '../../../themes/themes.js';
import '../../../themes/tooltip.js';
import '../../../styles/styled-components/font-face.js';
import '../../../styles/styled-components/global.js';
import { afterBeforeStyle, afterStyle, beforeStyle, getInputAddonTheme } from '../../../styles/styled-components/input.js';
import '../../../styles/styled-components/list.js';
import '../../../styles/styled-components/listitem.js';
import '../../../styles/styled-components/media-queries.js';
import '../../../styles/styled-components/reset.js';
import '../../../styles/styled-components/outline.js';
import '../../../styles/styled-components/popout.js';
import '../../../styles/styled-components/screen-reader.js';
import '../../../styles/styled-components/switch.js';
import '../../../styles/styled-components/tooltip.js';

var TextfieldAddonTypes = /*#__PURE__*/ function(TextfieldAddonTypes) {
    TextfieldAddonTypes["After"] = "after";
    TextfieldAddonTypes["Before"] = "before";
    return TextfieldAddonTypes;
}({});
const BaseTextfieldAddon = (props)=>{
    const { children, disabled, error, look, type, ...otherProps } = props;
    const { dir } = useRtl();
    return /*#__PURE__*/ React.createElement("span", {
        ...otherProps,
        "aria-hidden": true,
        className: classnames({
            'bf-textfield__addon': true,
            'bf-textfield__addon--disabled': disabled,
            'bf-textfield__addon--error': !!error,
            [`bf-textfield__addon--look-${look}`]: look,
            [`bf-textfield__addon--type-${type}`]: type,
            [`${otherProps?.className}`]: !!otherProps?.className
        }),
        dir: dir,
        role: "presentation"
    }, children);
};
const Addon = styled(BaseTextfieldAddon)`
  ${afterBeforeStyle}
  ${({ type })=>type === "after" ? afterStyle : beforeStyle}
  ${({ disabled, error, look })=>getInputAddonTheme({
        disabled,
        error,
        look
    })}
`;
const TextfieldAddon = (props)=>{
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Addon, props));
};

export { TextfieldAddon, TextfieldAddonTypes };
//# sourceMappingURL=textfield-addon.js.map
